import Settings from './Settings';
import Grid from '../gui/Grid';
import Storage from './Storage';
import View from '../gui/View';
import Spinner from '../gui/Spinner';
import Selection from '../shared/Selection';
import ZoomMenu from '../gui/ZoomMenu';
import Menu from '../gui/Menu';
import ToolCollection from '../tools/edit/ToolCollection';
import SideBar from '../sidebar/edit/SideBar';
import ElementCollection from '../shapes/ElementCollection';
import DataHandler from './DataHandler';
import { updateUnitSystem } from '../shared/utils';
import Cursor from '../gui/Cursor';
import PlantRow from '../sidebar/edit/PlantRow';
import Modal from '../gui/Modal';
import HoverSet from '../shared/HoverSet';
import SpeciesCollection from '../shared/SpeciesCollection';
import SpeciesInfo from '../sidebar/SpeciesInfo';
import ShapeFactory from '../shapes/ShapeFactory';
import DrawMenu from '../drawing/DrawMenu';
import TipBar from './TipBar';
import ImageMenu from '../gui/ImageMenu';
import ActionHandler from '../tools/actions/ActionHandler';

export default class ServiceProvider {
    constructor(p) {
        this.p = p;
    }

    init() {
        this.initValues();
        this.initInterface();
    }

    initValues() {
        this.mode = 'edit';
        this.planName = null;
        this.backgroundColor = this.p.color(240);
        this.enableHotKeys = true;
        this.spinner = new Spinner(this);
        this.selection = new Selection(this);
        this.hoverSet = new HoverSet(this);
        this.units = [];
        this.unsavedChanges = false;
        this.cursor = new Cursor(this);
        this.elementFactory = new ShapeFactory(this);
        this.actions = new ActionHandler();
        this.image = null;
        this.loaded = false;
    }

    initInterface() {
        this.storage = new Storage(this);
        this.dataHandler = new DataHandler(this);

        this.settings = new Settings(this);
        this.sideBar = new SideBar(this);
        this.sideBar.init();

        this.speciesInfo = new SpeciesInfo(this);

        this.zoomMenu = new ZoomMenu(this);
        this.zoomMenu.init();

        this.menu = new Menu(this);
        this.menu.init(
            ['select', 'shapes', 'navigation', 'erase', 'image'],
            ['settings', 'help', 'reset', 'save'],
        );

        this.drawMenu = new DrawMenu(this);
        this.imageMenu = new ImageMenu(this);

        this.tools = new ToolCollection(this);
        this.tools.init();

        this.grid = new Grid(this);

        this.view = new View(this);
        this.grid.recalculate();

        this.speciesCollection = new SpeciesCollection(this);
        this.elements = new ElementCollection(this);

        this.sideBar.activate();

        this.tips = new TipBar(this);

        this.dataHandler.getData();

        updateUnitSystem(this);
    }

    changesMade(silent = false) {
        if (!silent) {
            clearTimeout(this.saving);
            this.saving = setTimeout(() => this.storage.save(), 200);
        }
        if (!this.unsavedChanges) {
            this.unsavedChanges = true;
            window['saveButton'].style('color', '#ff0000');
        }
    }

    changesSaved() {
        this.unsavedChanges = false;
        window['saveButton'].html('Save');
        window['saveButton'].style('color', '#000000');
    }

    savePlan() {
        this.dataHandler.savePlan();
    }

    newPlantRow(species, container) {
        return new PlantRow(this, species, container);
    }

    showWelcomeMessage() {
        let welcomeMessage = new Modal(this);
        welcomeMessage
            .onClickOutside(() => welcomeMessage.remove())
            .setTitle('Welcome')
            .addContent(this.p.createP(
                "Welcome to the garden planner! This is an early version, so please be patient with us as we work out the kinks and expand features."
            ))
            .addContent(this.p.createP(
                "To add plants, use the sidebar on the right to search the database for plants or select them from your lists. There, you will also find details about the plants and an overview of all plants in your garden plan."
            ))
            .addContent(this.p.createP(
                "You can also draw shapes and you can add plants to those! Multiple! This allows you to draw garden beds, for example, without having to place each individual plant."
            ))
            .addContent(this.p.createP(
                "Use the menu in the topleft to add shapes, navigate, erase, change settings or find all the hotkeys available to you.."
            ))
            .addContent(this.p.createP(
                "If you have any questions or any feedback at all, please <a href='mailto:hello@permapeople.org' target='_blank'>email us</a> or join us on <a href='https://discord.gg/t6PP5BsJR2' target='_blank'>discord</a>."
            ))
            .setButtonText('Get started!')
            .onClickButton(() => welcomeMessage.remove());
    }

    showMigrationMessage() {
        let migrationMessage = new Modal(this);
        migrationMessage
            .onClickOutside(() => migrationMessage.remove())
            .setTitle('Lots of changes!')
            .addContent(this.p.createP(
                'We\'ve made quite the overhaul of the system. We\'ve removed the distinction between shapes and plants. All plants are shapes and all shapes can contain plants! Multiple even! This allows you to draw garden beds, for example, without having to place each individual plant.'
            ))
            .addContent(this.p.createP(
                "You now also have the option to change the appearance of your plants. You can change the color and the stroke around. You can also adjust the layering to control what goes on top and what goes below."
            ))
            .addContent(this.p.createP(
                "You can now also change the name of the plan or delete it in the settings menu."
            ))
            .addContent(this.p.createP(
                "And as always, if you have any questions or any feedback at all, please <a href='mailto:hello@permapeople.org' target='_blank'>email us</a> or join us on <a href='https://discord.gg/t6PP5BsJR2' target='_blank'>discord</a>."
            ))
            .setButtonText('Explore what\'s new!')
            .onClickButton(() => migrationMessage.remove());
    }
}
